/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { getProcessEnvs, PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { mockModel } from '../../mocks/mockModel';
import { NEXT_PUBLIC_ENV_KEYS } from '@marriott/mi-category-components';
import signatures from '../../signatures/operationSignaturesDestinations.json';
import moment from 'moment';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

const { SESSION_APP_DOMAIN_URL } = process.env;

function pageRenderer(props) {
  console.log('Category [page] props ', props);
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const outdoorsSpecificData = async (context: { [key: string]: any } | undefined) => {
  console.log('Category Outdoor Resolved URL:', context?.resolvedUrl);
  console.log('Category Outdoor operationSignatures', signatures);
  const { GOOGLE_MAP_API_KEY } = getProcessEnvs();
  const [featureFlagLogo, featureFlagAemltsHost] = await Promise.all([
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
      target: TARGETS.APP.CATEGORY_RENDERER,
    }),
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_CATEGORY_RENDERER_AEMLTS_HOST, {}),
  ]);
  const featureFlags = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS, {
    target: TARGETS.APP.CATEGORY_RENDERER,
  });
  console.log('AEM LTS Host Feature Flags:', featureFlagAemltsHost);
  const useAemLtsHost = featureFlagAemltsHost?.experience_mcom_category_renderer_aemlts_host;
  const aemHost = useAemLtsHost ? process.env.NEXT_PUBLIC_AEM_LTS_HOST : process.env.NEXT_PUBLIC_AEM_HOST;
  return {
    operationSignatures: signatures,
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    GOOGLE_MAP_API_KEY,
    featureFlagAemltsHost: featureFlagAemltsHost ?? null,
    aemHost: aemHost ?? null,
    featureFlags: { featureFlagLogo, featureFlags },
  };
};

const postAEMModelOperations = async (
  context: any,
  parallelCallsResponse: any,
  _interceptorResponse: any,
  model: any
) => {
  const { req } = context;
  const sessionID = req?.cookies?.sessionID ?? '';
  const { sessionData } = parallelCallsResponse;

  // Update AriesSearch in session with outdoor destination metadata
  // This populates the SearchField destination value from session
  const updateSessionData = async (destinationMetaData: any) => {
    const today = moment().utc().startOf('day').toISOString();
    const tomorrow = moment().utc().add(1, 'days').startOf('day').toISOString();
    let ariesSearch: any = sessionData?.cacheData?.data?.AriesSearch;

    // Build AriesSearch object with destination details and default search criteria
    ariesSearch = {
      ...ariesSearch,
      searchCriteria: {
        ...ariesSearch?.searchCriteria,
        // Destination address information from model metadata
        address: {
          city: destinationMetaData?.city || '',
          country: destinationMetaData?.countryCode || '',
          destination: destinationMetaData?.destinationName || '', // This value is displayed in SearchField
          latitude: parseFloat(destinationMetaData?.latitude) || '',
          longitude: parseFloat(destinationMetaData?.longitude) || '',
          stateProvince: destinationMetaData?.stateCode || '',
          stateProvinceDisplayName: destinationMetaData?.stateCode || '',
          destinationType: 'City',
        },
        countryName: destinationMetaData?.country || '',
        destinationAddressPlaceId: destinationMetaData?.placeId || '',
        geoCode: `${destinationMetaData?.latitude}, ${destinationMetaData?.longitude}`,
        // Default availability search parameters
        availabilityRequestVO: {
          ...ariesSearch?.searchCriteria?.availabilityRequestVO,
          checkInDate: today,
          checkOutDate: tomorrow,
          flexibleDate: false,
          lengthOfStay: 1,
          flexibleDateSearchRateDisplay: false,
          hideFlexibleDateCalendar: false,
          numAdultsPerRoom: 1,
          numChildrenPerRoom: 0,
          numGuestsPerRoom: 1,
          numRooms: 1,
        },
      },
      search_date_type: 'With Dates',
      search_dates_flexible: false,
    };

    // Update session with AriesSearch - this enables SearchField to read destination value
    try {
      const url = `${SESSION_APP_DOMAIN_URL}/phoenix-gateway/session`;
      const headers = {
        Cookie: `sessionID=${sessionID}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      };
      const payload = {
        createOrUpdate: {
          AriesSearch: ariesSearch,
        },
        remove: [],
        sessionToken: sessionID,
      };
      await fetch(url, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(data => {
          return data?.status;
        });
    } catch (error) {
      console.log(`[OUTDOOR] update session API Failed:, ${error}`);
    }
  };

  // Initialize session if destination metadata exists in model
  if (model?.destinationMetaData) {
    await updateSessionData(model?.destinationMetaData);
  }
  return model;
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
export const getServerSideProps: GetServerSideProps<any> = prePageCall(
  outdoorsSpecificData,
  mockModel,
  false,
  false,
  false,
  undefined,
  postAEMModelOperations
);
export default pageRenderer;
